<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">
				<span style="margin-right: 10px">租控状态统计</span>
				<!-- <el-tag size="mini" type="success">{{ total }}个</el-tag> -->
			</div>
			<div
				style="color: #409eff; font-size: 14px; cursor: pointer"
				@click="
					() => {
						this.$router.push('/pages/assets/leaseControlMap');
					}
				">
				更多
			</div>
		</div>
		<div class="status-grid">
			<div v-for="item in statusList" :key="item.label" class="status-item">
				<div class="status-item-header">
					<div class="label">{{ item.label }}</div>
					<div class="count">{{ item.count }}个</div>
				</div>
				<el-progress
					:percentage="total ? (item.count / total) * 100 : 0"
					:stroke-width="8"
					:show-text="false"
					:color="item.color"></el-progress>
			</div>
		</div>
		<div class="percentage-row">
			<svg-icon name="rent" :size="42" />
			<div class="percentage-label">整体出租率</div>
			<div class="tip">
				<el-tooltip
					class="item"
					effect="dark"
					content="整体出租率=已出租数量/（已出租数量+已预订数量+空置可租数量)"
					placement="top">
					<i class="fa fa-question-circle-o" style="color: #999; font-size: 14px"></i>
				</el-tooltip>
			</div>
			<div class="percentage">
				<span>{{ rentRate }}%</span>
			</div>
		</div>
	</el-card>
</template>

<script>
	import { statisticRoomStatus } from '@/api/assets/occupancyMapApi.js';
	import { getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'LeaseStatusStatistics',
		props: {
			assetRentStats: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				statusList: [
					{ count: 0, label: '已出租', color: '#67C23A', key: 'rentedCount' },
					{ count: 0, label: '空置可租', color: '#E6A23C', key: 'availableCount' },
					{ count: 0, label: '装修中', color: '#409EFF', key: 'renovatingCount' },
					{ count: 0, label: '已预订', color: '#8E44AD', key: 'reservedCount' },
				],
				total: 0,
				rentRate: '',
			};
		},
		watch: {
			assetRentStats: {
				handler(newVal) {
					if (!newVal) return;
					this.statusList.forEach(item => {
						item.count = newVal[item.key] || '0';
					});
					this.total = newVal.total;
					this.rentRate = newVal.rentRate;
				},
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		height: calc(100% - 38px);
		display: flex;
		flex-direction: column;
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}

	.title {
		font-weight: bold;
	}

	.status-grid {
		flex: 1;
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.status-item {
		width: 100%;
		box-sizing: border-box;
	}

	.status-item-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 4px;
	}

	/* 文本 */
	.label {
		font-weight: 400;
		font-size: 14px;
		color: #000000;
	}

	/* 数字 */
	.count {
		font-weight: bold;
		font-size: 12px;
		color: #0f172a;
	}

	.percentage-row {
		margin-top: 13px;
		padding: 17px 24px 0px 24px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #3e3e3e;
	}

	.percentage-label {
		margin-left: 13px;
		margin-right: 8px;
	}

	.tip {
		flex: 1;
		cursor: help;
	}

	.percentage {
		font-weight: 600;
		font-size: 28px;
		color: #1c1c1c;
	}
</style>
